import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/src/layout.tsx";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ContentColumns = makeShortcode("ContentColumns");
const Card = makeShortcode("Card");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ContentColumns mdxType="ContentColumns">{[<Card key="rools" variant="vertical" image="izby/apartman-rodinny.jpg" title="Comfort in Cozy Rooms" to="/en/rooms/" mdxType="Card">
		Rooms and apartments with stunning views of the nearby hillside and surrounding nature.
	</Card>, <Card key="restauracia" variant="vertical" image="restauracia/13.jpg" title="Home-Style Cooking" to="/en/restaurant/" mdxType="Card">
		We love our traditional Slovak dishes, prepared in-house with care and love.
	</Card>, <Card key="okolie" variant="vertical" image="okolie/20200516_181238.jpg" title="Relaxation in the Heart of Nature" to="/en/area/" mdxType="Card">
		Wherever you look, you’ll be enchanted by the beauty of nature, its peacefulness, and undisturbed silence
	</Card>]}</ContentColumns>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      